export enum PlaybackState {
    IDLE = 'idle',
    STOPPED = 'stopped',
    PLAYING = 'playing',
    PAUSED = 'paused',
    WAITING = 'waiting',
}
